<template>
    <div class="m-content">
        <div v-if="loading || info.show || error.show" class="text-center">
            <spinner v-if="loading" line-fg-color="#E95253" size="large" class="m--padding-top-150" message="Loading..."></spinner>
            <div v-if="info.show" class="info-message m--padding-top-80">
                <img src="../../../static/img/info.png" alt="error" />
                <p class="m--margin-top-15">{{ info.message }}</p>
            </div>
            <div v-if="error.show" class="error-message m--padding-top-50">
                <img src="../../../static/img/error.png" alt="error" />
                <p class="m--margin-top-15">{{ error.message }}</p>
            </div>
        </div>
        <slot v-else name="content"></slot>
    </div>
</template>
<script>
import Spinner from "vue-simple-spinner";

export default {
  name: "Content",
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    info() {
      return this.$store.state.info;
    },
    error() {
      return this.$store.state.error;
    }
  },
  components: {
    Spinner
  }
};
</script>




// WEBPACK FOOTER //
// src/components/partials/Content.vue